const volcanes = {
  payingByMessage: 'Pagando via ',
  safePaymentPage: 'Página de pagamento segura',
  finishYourPaymentMessage: 'Termine sua compra, finalize aqui seu pagamento :)',
  inputCustomerName: 'Nome',
  inputCustomerEmail: 'Email',
  inputCustomerPhoneNumber: 'Telefone',
  inputCustumerPhoneNumberOptional: '(opcional)',
  emptyCardSecurityCode: 'Preencha o código de segurança do cartão',
  invalidSecurityCode: 'Código de segurança inválido',
  invalidCvv: 'CVV inválido',
  fieldCardSecurityCode: 'Código de Segurança (CVV)',
  fieldCardHolderName: 'Nome (como impresso no cartão)',
  fieldCardExpiryDate: 'Validade do cartão',
  placeholderCardExpiryDate: 'MM/AAAA',
  fieldCardNumber: 'Número do Cartão',
  fieldOneClickCardNumber: '{brand} final {lastFour}',
  transactionFeeTooltip: 'Custos de Processamento',
  total: 'Total',
  amount: 'Valor',
  termsLabel: 'Ao continuar você aceita os  ',
  termsReferenceLink: 'termos de uso',
  termsEbanxLabel: '  do EBANX.',
  paymentPageTitle: 'Página de pagamento',
  selectPaymentMethod: 'Selecione um método de pagamento',
  fatalErrorTitle: 'Oops!',
  fatalErrorMessage: 'Infelizmente não conseguimos encontrar os dados do seu pagamento.',
  fatalErrorFooter: 'Pagamento seguro via',
  panamaUsdDisclaimer: 'Os pagamentos são processados pelo EBANX. Devido ao roteamento regional, seu extrato bancário pode fazer referência ao Panamá (PAB), que mantém uma paridade fixa de 1:1 com o USD. O valor final cobrado deve refletir o preço em USD exibido.',
  merchantPaymentCode: 'Pedido #',
};

module.exports = volcanes;
